import { Stack, TextField, Checkbox, FormControlLabel } from '@mui/material';
import React, { useEffect } from 'react';
import { DialogConfirm } from 'app/components/elements/DialogConfirm';
import { useForm, Controller } from 'react-hook-form';
import { ButtonCustom } from '../../../components/elements/ButtonCustom';
import dayjs from 'dayjs';

type FormReminderProps = {
  isOpen: boolean;
  handleClose: () => void;
  onSubmit: (value: FormValues) => void;
};

type FormValues = {
  date: string;
  time: string;
  note: string;
  showAdmin: boolean;
  showBailiff: boolean;
};

const REMINDER_NOTE_MAX_LENGTH = 5000;

export const FormReminder = ({ onSubmit, isOpen, handleClose }: FormReminderProps) => {
  const { control, handleSubmit, reset } = useForm<FormValues>({
    defaultValues: {
      date: '',
      time: '',
      note: '',
      showAdmin: true,
      showBailiff: true
    }
  });

  useEffect(() => {
    if (!isOpen) {
      reset({
        date: '',
        time: '',
        note: '',
        showAdmin: true,
        showBailiff: true
      });
    }
  }, [isOpen]);

  return (
    <DialogConfirm width={'600px'} isOpen={isOpen} onClose={handleClose} textTitle={'Reminder'}>
      <Stack spacing={2} width={'100%'}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} width="100%">
          <Controller
            name="date"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="medium"
                inputProps={{
                  min: dayjs().format('YYYY-MM-DD')
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: '1rem',
                    '& fieldset': { borderWidth: 2 }
                  }
                }}
              />
            )}
          />
          <Controller
            name="time"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Time"
                type="time"
                InputLabelProps={{ shrink: true }}
                fullWidth
                size="medium"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    fontSize: '1rem',
                    '& fieldset': { borderWidth: 2 }
                  }
                }}
              />
            )}
          />
        </Stack>
        <Controller
          name="note"
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              label="Reminder Note"
              multiline
              rows={4}
              fullWidth
              size="medium"
              inputProps={{
                maxLength: REMINDER_NOTE_MAX_LENGTH
              }}
              helperText={`${field.value?.length || 0}/${REMINDER_NOTE_MAX_LENGTH}`}
              sx={{
                '& .MuiOutlinedInput-root': { fontSize: '1rem', '& fieldset': { borderWidth: 2 } }
              }}
            />
          )}
        />
        <Stack direction="row" spacing={2}>
          <Controller
            name="showAdmin"
            control={control}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox {...field} checked={field.value} />}
                label="Show Admin"
              />
            )}
          />
          <Controller
            name="showBailiff"
            control={control}
            render={({ field }) => (
              <FormControlLabel
                control={<Checkbox {...field} checked={field.value} />}
                label="Show Bailiff"
              />
            )}
          />
        </Stack>
        <ButtonCustom onClick={handleSubmit(onSubmit)} label={'Submit'} />
      </Stack>
    </DialogConfirm>
  );
};
